// src/components/SystemIcon.jsx
// แสดงไอคอนระบบ: ภาพ (base64 data URL / URL) หรือตัวอักษร/อีโมจิ
// ใช้ร่วมกับค่าตั้งค่าเว็บไซต์ (site_settings.system_icon)
import React from 'react';

export const DEFAULT_SYSTEM_ICON = '🛕';

const isImage = (value) =>
  typeof value === 'string' &&
  (value.startsWith('data:') ||
    value.startsWith('http://') ||
    value.startsWith('https://'));

const SystemIcon = ({ icon, size = 22, className, style }) => {
  const value = icon || DEFAULT_SYSTEM_ICON;

  if (isImage(value)) {
    return (
      <img
        src={value}
        alt="ไอคอนระบบ"
        className={className}
        style={{
          width: size,
          height: size,
          objectFit: 'contain',
          ...style,
        }}
      />
    );
  }

  return (
    <span className={className} style={{ fontSize: size, lineHeight: 1, ...style }}>
      {value}
    </span>
  );
};

export default SystemIcon;
